import { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { Toaster } from 'react-hot-toast'

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient,
  auth: any,
}>()({
  component: () => (
    <>
      <Outlet />
      <Toaster />
    </>
  ),
})
